import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import('pages/supplier/SupplierEnterpriseContact/SupplierEnterpriseContactListPage'));

export default [{ component, exact: true, path: '/supplier_enterprise_contacts' }];